module.exports = __webpack_public_path__ + "static/media/banner.d404f3e0.png";